import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43296 32112"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M4849 30759h33599v-2841H4849v2841zm34276 1353H4172c-373 0-676-303-676-677v-4194c0-374 303-677 676-677h34953c374 0 675 303 675 677v4194c0 374-301 677-675 677zM4849 22370h33598c-72-8518-7024-15424-15558-15424h-2481c-8535 0-15486 6906-15559 15424zm34276 1354H4172c-373 0-676-303-676-677v-541c0-2284 447-4497 1329-6585 851-2013 2071-3821 3623-5374 1555-1554 3362-2772 5377-3625 2085-882 4300-1329 6583-1329h2481c2282 0 4497 447 6582 1329 2015 853 3824 2071 5377 3625 1552 1553 2772 3361 3623 5374 882 2088 1329 4301 1329 6585v541c0 374-301 677-675 677z"
        className="fil0"
      />
      <path
        d="M42620 32112H677c-374 0-677-303-677-677 0-375 303-676 677-676h41943c373 0 676 301 676 676 0 374-304 677-676 677zM18131 26564h2841v-2840h-2841v2840zm3517 1354h-4194c-374 0-677-303-677-677v-4194c0-374 303-677 677-677h4194c374 0 677 303 677 677v4194c0 374-303 677-677 677z"
        className="fil0"
      />
      <path
        d="M22325 26564h2841v-2840h-2841v2840zm3518 1354h-4195c-374 0-676-303-676-677v-4194c0-374 302-677 676-677h4195c373 0 676 303 676 677v4194c0 374-303 677-676 677zM23046 6959c-373 0-677-303-677-675V4149h-1442v2135c0 372-304 676-676 676-375-1-677-304-677-676V3473c0-374 301-676 677-676h2795c374 0 677 302 677 676v2811c0 372-303 676-677 675z"
        className="fil0"
      />
      <path
        d="M18216 2797h6864c-252-835-1028-1443-1943-1443h-2977c-915 0-1692 608-1944 1443zm7627 1352h-8389c-374 0-677-303-677-676v-90c0-1864 1519-3382 3383-3382l2977-1c1865 0 3382 1519 3382 3383v90c0 373-303 676-676 676zM35629 7645c-373 0-676-303-676-677 0-1555-1264-2819-2819-2819-374 0-677-303-677-676 0-374 303-676 677-676 2300 0 4172 1871 4172 4171 1 374-303 677-677 677z"
        className="fil0"
      />
      <path
        d="M38425 7645c-374 0-675-303-675-677 0-3096-2520-5614-5616-5614-374 0-677-303-677-677s303-676 677-676c1862-1 3611 724 4927 2040s2041 3065 2041 4927c0 374-303 677-677 677zM7668 7645c-374 0-678-303-678-677 1-2300 1871-4171 4173-4171 374 0 676 302 676 676 0 373-302 676-676 676-1554 0-2818 1265-2818 2819 0 374-303 677-677 677z"
        className="fil0"
      />
      <path
        d="M4871 7645c-374 0-676-303-676-677 1-1862 725-3611 2041-4927C7551 725 9301 1 11163 1c374-1 676 302 676 676s-302 677-676 677c-3097 0-5615 2518-5615 5614 0 374-303 677-677 677z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
